// Shared client-side types — mirror the kit-engine contracts so the review UI
// edits exactly what the engine consumes:
//   extraction:  kit_engine/intake_schema.py   (WordListExtraction)
//   words:       kit_engine/tests/fixtures/m2_week1.json
//   kit/job:     Firestore `kits/{id}` metadata + Storage artifact refs ONLY
//                (1MB doc limit — PDFs live in Storage, never inline; ARCHITECTURE.md §3)

export type ExtractionSection = { name: string; words: string[] };

export type Extraction = {
  title: string;
  grade?: string;
  week?: string;
  sections: ExtractionSection[];
};

export type Kid = {
  id: string;
  name: string;
  grade: string;
  themes: string[];
};

export type KitArtifact = { kind: "flashcards" | "wordsearch" | "crossword" | "handwriting" | "booklet"; path: string; pages?: number };

export type KitStatus = "queued" | "building" | "validating" | "ready" | "failed";

export type Kit = {
  id: string;
  kidId: string;
  title: string;
  week: string;
  status: KitStatus;
  error?: string;
  artifacts: KitArtifact[];
  bookletFormat?: "saddle" | "flat";
  wordCount: number;
  extraction?: Extraction; // stored source of truth — enables "duplicate"
  theme?: string;
  // #39 "generate another": variant kits carry regen:{of,kinds}; `of` is the
  // ROOT module id (the callable resolves the chain server-side).
  regen?: { of: string; kinds: string[] };
  createdAt: number;
};

// Word shape check identical to intake_schema.WORD_RE (server is truth):
// letters + internal ASCII/curly apostrophe/hyphen, no digits, no dots,
// max 21 chars. Words the server would reject surface as bad chips at review.
export const WORD_RE = /^[A-Za-z][A-Za-z'’\-]{0,20}$/;
